import { TrendingDown, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";

interface KeywordTrendProps {
  /** Raw search-volume trend, e.g. "4.65000", 4.65 or "-26.32000". */
  value: string | number | null | undefined;
  className?: string;
}

/**
 * One rendering of a keyword's search-volume trend, shared by the Keywords page and the
 * SEO Strategy Recommended Tests table. The stored value is a raw decimal string
 * ("4.65000"), so it needs converting before display -- rendering it verbatim shows
 * trailing zeros and no percent sign.
 */
export function KeywordTrend({ value, className }: KeywordTrendProps) {
  if (value === null || value === undefined || value === "") return <>—</>;

  const numeric = Number(value);

  if (!Number.isFinite(numeric)) return <>—</>;

  const isNegative = numeric < 0;

  return (
    <span
      className={cn(
        "inline-flex max-w-full min-w-0 items-center justify-center gap-0.5 tabular-nums text-xs",
        isNegative ? "text-destructive" : "text-[hsl(var(--trend-positive))]",
        className,
      )}
    >
      {isNegative ? <TrendingDown className="h-3 w-3 shrink-0" /> : <TrendingUp className="h-3 w-3 shrink-0" />}
      {Math.abs(numeric)}%
    </span>
  );
}
